import { createAppKit } from '@reown/appkit/vue';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { baseSepolia, base } from '@reown/appkit/networks';
import { http, createStorage, cookieStorage } from '@wagmi/core';
import { injected } from 'wagmi/connectors';
import { createClient } from 'viem';

const isProduction = process.env.VUE_APP_ENV === 'production';
const projectId = process.env.VUE_APP_WALLET_PROJECT_ID;
const network = isProduction ? base : baseSepolia;

const storage = createStorage({
  storage: cookieStorage,
});

export const connectors = [];
connectors.push(injected({ shimDisconnect: true, }));

export const networks = [network];
export const PLATFORM_WALLET_ADDRESS = process.env.VUE_APP_PLATFORM_WALLET_ADDRESS
export const wagmiAdapter = new WagmiAdapter({
  storage: storage,
  connectors: connectors,
  projectId: projectId,
  networks: networks,
  client({ chain }) {
    return createClient({ chain, transport: http() })
  },
});

export const walletConfig = wagmiAdapter.wagmiConfig;

const metadata = {
    name: 'PortexAI Datalab',
    description: 'The Portex Datalab is an expert eval and frontier AI data acquisition platform.',
    url: isProduction ? 'https://datalab.portexai.com/' : 'https://datalab-dev.portexai.com/',
    icons: ['https://0xpledges.com/images/portex_logo_no_bg.png'],
}

export const walletModal = createAppKit({
  adapters: [wagmiAdapter],
  networks: networks,
  projectId: projectId,
  metadata: metadata,
  featuredWalletIds: [
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
    'fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa',
  ],
  includeWalletIds: [
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
    'fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa',
  ],
  allWallets: 'HIDE',
  features: {
    email: false,
    socials: false,
    analytics: false,
  },
  enableWalletConnect: false,
});
